import { ANALYTICS_FILTERS } from "constants/types/analyticsTypes";

const initialState = {
  filterApplied: false,
};
export const analyticsFiltersReducer = (state: any = initialState, action: any) => {
  const newState = { ...state };
  switch (action.type) {
    case ANALYTICS_FILTERS.APPLY:
      newState.filterApplied = true;
      return newState;
    case ANALYTICS_FILTERS.RESET:
      newState.filterApplied = false;
      return newState;
    default:
      return newState;
  }
};
